import { Check } from "lucide-react";
import React from "react";

export const CheckIcon = () => {
  return (
    <div
      className="flex h-[64px] w-[64px] items-center justify-center rounded-full bg-success-primary"
      aria-hidden="true"
      tabIndex={-1}
    >
      <Check className="h-[32px] w-[32px] text-background" />
    </div>
  );
};
